import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Article = {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt: string;
  seo_title: string | null;
  seo_description: string | null;
  seo_keywords: string | null;
  category: string;
  category_id: string | null;
  tags: string[];
  status: 'draft' | 'published';
  views_count: number;
  author_id: string | null;
  published_at: string | null;
  created_at: string;
  updated_at: string;
  main_image_url: string | null;
  main_image_alt: string | null;
  main_image_title: string | null;
  main_image_description: string | null;
};

export type SocialLink = {
  id: string;
  name: string;
  url: string;
  icon: string;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type Category = {
  id: string;
  name: string;
  slug: string;
  description: string;
  display_order: number;
  url: string;
  nofollow: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type Page = {
  id: string;
  title: string;
  slug: string;
  content: string;
  external_url: string | null;
  page_type: string;
  seo_title: string | null;
  seo_description: string | null;
  seo_keywords: string | null;
  seo_index: boolean;
  seo_follow: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type FooterSettings = {
  id: string;
  content: string;
  copyright_text: string;
  contact_email: string | null;
  contact_phone: string | null;
  updated_at: string;
};

export type HeaderSettings = {
  id: string;
  logo_url: string;
  logo_height: number;
  logo_link: string;
  logo_alt: string;
  logo_title: string;
  logo_description: string;
  subtitle_text: string;
  subtitle_font_size: string;
  subtitle_color: string;
  title_text: string;
  title_font_family: string;
  title_font_size: string;
  title_color: string;
  background_color: string;
  menu_font_size: string;
  menu_color: string;
  menu_hover_color: string;
  content_alignment: string;
  updated_at: string;
};

export type MenuItem = {
  id: string;
  label: string;
  url: string;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type Widget = {
  id: string;
  name: string;
  type: string;
  title: string;
  content: string;
  settings: any;
  position: string;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};
